import React from "react";
import { Link } from "react-router";
import { Container, Header, List } from "semantic-ui-react";

function JsonYamlEditor() {
  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        JSON/YAML Editor
      </Header>
      <Header dividing>Introduction</Header>
      The <Link to="/developer-tools/json-yaml-editor">JSON/YAML Editor</Link> is a powerful tool designed to simplify
      working with JSON/YAML documents. It allows users to easily validate, copy, compress or prettify documents.
      <Header dividing>Features</Header>
      <List as="ul">
        <List.Item as="li">
          <b>Validate</b>
          <List as="ul">
            <List.Item>
              When you click on 'Validate' button JSON or YAML document will be validated. If there are no errors,
              message indicating that document is valid will be presented. Also, validation is performed in real time,
              so whenever there is an error in the document, the message will be presented immediately.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Copy</b>
          <List as="ul">
            <List.Item>
              When you click on 'Copy' button JSON or YAML document will be copied to the clipboard.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Convert between JSON and YAML formats</b>
          <List as="ul">
            <List.Item>
              When you click on 'Convert to JSON' or 'Convert to YAML' button your document will be converted to desired
              format.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Compress</b>
          <List as="ul">
            <List.Item>
              This is only valid for JSON document. When you click on 'Compress' button, all unnecessary spaces or line
              breaks will be removed. This is useful when publishing kafka messages with CLI clients.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Prettify</b>
          <List as="ul">
            <List.Item>
              When you click on 'Prettify' button, your JSON or YAML document will be nicely reformatted. You can
              specify tab width as two or four spaces.
            </List.Item>
          </List>
        </List.Item>
      </List>
    </Container>
  );
}

export default JsonYamlEditor;
